<script setup lang="ts">
import { cx } from '../ui'

withDefaults(
  defineProps<{
    align?: 'left' | 'right' | 'center'
    class?: string
  }>(),
  { align: 'left' },
)
</script>

<template>
  <th
    scope="col"
    :class="
      cx(
        'col-head px-4 py-2.5 text-left',

        align === 'right' && 'text-right',
        align === 'center' && 'text-center',
        $props.class,
      )
    "
  >
    <slot />
  </th>
</template>
